export enum GenericActions {
  GENERIC_SERVER_ERROR = 'GENERIC_SERVER_ERROR',
  FAILED_ACTION = 'FAILED_ACTION',
  GENERIC_SETTINGS_SAVED = 'GENERIC_SETTINGS_SAVED',
  GENERIC_SETTINGS_FAILED = 'GENERIC_SETTINGS_FAILED',
  GENERIC_COPIED_CLIPBOARD = 'GENERIC_COPIED_CLIPBOARD',
  GENERIC_COPY_FAILED = 'GENERIC_COPY_FAILED'
}
